var vSelectBox = require('./VSelectBox.vue')
module.exports = vSelectBox



//////////////////
// WEBPACK FOOTER
// ./node_modules/v-select-box/index.js
// module id = G8QD
// module chunks = 0